/* eslint-disable prefer-arrow-callback */
import moment from "moment";
import * as Yup from "yup";

Yup.addMethod(Yup.array, "unique", function (message, mapper = (a) => a) {
  // eslint-disable-next-line react/no-this-in-sfc
  return this.test("unique", message, (list) => list.length === new Set(list.map(mapper)).size);
});

const validationSchema = [
  Yup.object().shape({
    info: Yup.object().shape({
      name: Yup.string()
        .max(100, "Name cannot be more than 100 characters")
        .required("Name is required"),
      type: Yup.string().required("Type is required").typeError("Type is required"),
      description: Yup.string()
        .max(255, "Description cannot be more than 255 characters")
        .required("Description is required"),
      badge: Yup.string().required("Badge is required").typeError("Badge is required"),
      reward: Yup.string()
        .max(50, "Reward cannot be more than 100 characters")
        .when("type", {
          is: (val) => val === "Tremendous payout",
          then: Yup.string()
            .test((value, context) => {
              const isValidNumberValue = !Number.isNaN(Number(value));
              if (!isValidNumberValue)
                return context.createError({
                  message:
                    "Reward must be a valid number value when tremendous campaign id is used",
                });
              return isValidNumberValue;
            })
            .required("Reward must be a number value"),
        })
        .required("Reward is required"),
      campaignId: Yup.string().when("type", {
        is: (val) => val === "Tremendous payout",
        then: Yup.string()
          .test((value, context) => {
            if (!value || value === "None")
              return context.createError({
                message: "Must select valid campaign",
              });

            return true;
          })
          .required("Campaign must be selected"),
      }),
    }),
  }),
  Yup.object().shape({
    criteria: Yup.object().shape({
      winCondition: Yup.object().required("Criteria is required").typeError("Criteria is required"),
      target: Yup.number().when("winCondition", {
        is: (winCondition) => winCondition?.condition === "First To KPI Target",
        then: Yup.number()
          .required("KPI Target is required")
          .typeError("KPI Target is required")
          .min(1, "Minimum Target is 1"),
        otherwise: Yup.number().nullable(),
      }),
      kpiActivities: Yup.array()
        .of(
          Yup.object().shape({
            id: Yup.number().nullable(),
            name: Yup.string().required("Please select KPI").typeError("Please select KPI"),
            points: Yup.number()
              .test("required", "Point is required", function (value, ctx) {
                if (ctx?.from?.[1]?.value?.criteria === "Total Points" && !value) {
                  return false;
                }
                return true;
              })
              .test("value validation", "Invalid Point", function (value, ctx) {
                if (
                  ctx?.from?.[1]?.value?.criteria === "Total Points" &&
                  (value < 1 || value > 999)
                ) {
                  return false;
                }
                return true;
              }),
            count: Yup.number()
              .test("required", "Count is required", function (value, ctx) {
                if (ctx?.from?.[1]?.value?.criteria === "Total Points" && !value) {
                  return false;
                }
                return true;
              })
              .test("value validation", "Invalid Count", function (value, ctx) {
                if (
                  ctx?.from?.[1]?.value?.criteria === "Total Points" &&
                  (value < 1 || value > 999)
                ) {
                  return false;
                }
                return true;
              }),
          })
        )
        .unique("New KPI names cannot be same.", (a) => a?.name?.trim())
        .min(1, "Add atleast one question"),
    }),
  }),
  Yup.object().shape({
    duration: Yup.object().shape({
      startDate: Yup.date()
        .required("Start Time is required")
        .typeError("Start Time is required")
        .test(
          "invalid start time",
          "Start Time must be 15 minutes greater than selected timezone's current time",
          function (value, ctx) {
            const timezone = ctx?.from?.[0].value?.timezone;

            if (
              value &&
              moment.tz(value, timezone).isBefore(moment.tz(undefined, timezone).add(15, "minutes"))
            ) {
              return false;
            }
            return true;
          }
        ),
      endDate: Yup.date()
        .nullable()
        .typeError()
        .test("required", "End Time is required", function (value, ctx) {
          if (
            ctx?.from?.[1]?.value?.criteria?.winCondition?.condition !== "First To KPI Target" &&
            !value
          ) {
            return false;
          }
          return true;
        })
        .test(
          "invalid end time",
          "End Time must be  5 minutes greater than start time",
          function (value, ctx) {
            const timezone = ctx?.from?.[0].value?.timezone;

            if (
              value &&
              moment
                .tz(value, timezone)
                .isBefore(moment.tz(ctx?.from?.[0].value?.startDate, timezone).add(5, "minutes"))
            ) {
              return false;
            }

            return true;
          }
        ),
      timezone: Yup.string().required("Timezone is required"),
      repeatCompetition: Yup.boolean(),
      repeatInterval: Yup.string()
        .nullable()
        .when("repeatCompetition", {
          is: true,
          then: Yup.string().required("Repeat interval is required"),
        }),
    }),
  }),
];

export default validationSchema;
